import { isDesktop } from './Utils.js';

export default class AnchorNavigationContoller {    
    static isAnyPartOfElementInViewport(el) {    
        const rect = el.getBoundingClientRect();
        const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
        const windowWidth = (window.innerWidth || document.documentElement.clientWidth);
        const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
        const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

        return (vertInView && horInView);
    }
    
    static getTargetElement(lielem) {
        if (!lielem)
            return null;
        
        let aelem = lielem.querySelector("a");
        if (!aelem)
            return null;
        return document.getElementById(aelem.dataset.target);
    }
    
    getBestTarget() {
        let result = null;
        let targets =  this.navigation.querySelectorAll("a");
        let done = false;
        targets.forEach(function(el) {
            if (done)
                return;
            
            let current = document.getElementById(el.dataset.target);
            if (current) {
                if (AnchorNavigationContoller.isAnyPartOfElementInViewport(current)) {
                    result = current;
                    done = true;
                }
            }
        });        
        return result;
    }
    
    setActiveElement(elem, force) {
        if (!force) {
            let best = this.getBestTarget();
            if (best) {
                let active = this.navigation.querySelector("li.active");
                let activeelem = AnchorNavigationContoller.getTargetElement(active);
                if (best == activeelem)
                    return;
            
                let bestnavelem = this.navigation.querySelector(`a[data-target=${best.id}]`);
                if (bestnavelem) {
                    this.setActiveElement(bestnavelem.parentNode, true);
                    return;
                }
            }
        }
        
        let lis = this.navigation.querySelectorAll("li");
        lis.forEach(function(el) {
            el.classList.remove("active");            
        });
        elem.classList.add("active");
        this.navigation.scrollLeft = elem.offsetLeft;
        let overlay = document.getElementById("gradient-overlay");
        if (overlay) {
            overlay.style.left = "" + this.navigation.scrollLeft + "px";
            if (lis.length) {
                if (elem == lis[lis.length - 1])
                    overlay.classList.add("left");
                else
                    overlay.classList.remove("left");
            }
        }
    }
        
    constructor(nav) {
        this.navigation = nav;
        this.clicking = false;
        
        let options = 
        {
            root: null, // relative to document viewport
            rootMarging: '0px',
            threshold: 0
        }

        const that = this;
        let callback = (entries) => {
            entries.forEach((entry) => {
                if (!that.clicking) {
                    let id = entry.target.id;
                    let navelem = nav.querySelector(`a[data-target=${id}]`);
                    if (!navelem)
                        return;

                    this.setActiveElement(navelem.parentNode, false);
                }
            });
        };

        let observer = new IntersectionObserver(callback, options);
        let targets = nav.querySelectorAll("a");
        targets.forEach(function(el) {
            el.addEventListener('click', () => {
                that.clicking = true;
                setTimeout(function() {
                    that.setActiveElement(el.parentNode, true);
                    that.clicking = false;
                }, 500);
            });
            let oelem = document.getElementById(el.dataset.target);
            if (oelem)
                observer.observe(oelem);
            else
                console.log(`Warning: Target element ${el.dataset.target} not found`);
        });
    }
        
    static position(nav) {
        // https://iservice.sos-kd.org/browse/DIGSP-4912
        if (isDesktop()) {
            // Add it at the bottom of the main navigation
            let navbar = document.querySelector("div.sos-main-nav > div.sticky-wrapper");
            if (navbar) {
                navbar.appendChild(nav);
                nav.classList.add("anchor-list-initialized");
                return true;
            }        
        }
        else {
            let navbar = document.querySelector(".navbar-fixed-top");
            if (navbar && navbar.parentNode) {
                navbar.parentNode.appendChild(nav);
                nav.classList.add("anchor-list-initialized");
                nav.style.position = "fixed";
                let overlay = document.createElement('div');
                overlay.id = "gradient-overlay";
                overlay.classList.add("overlay");
                nav.appendChild(overlay);
                navbar.parentNode.style.marginBottom = `${nav.getBoundingClientRect().height}px`;
                return true;
            }        
        }
        return false;
    }

    static init() {
        let navi = document.querySelector('.anchor-navigation');
        if (navi == null)
            return;
        if (navi.classList.contains("anchor-list-initialized"))
            return;
        if (!AnchorNavigationContoller.position(navi))
            // Maybe initialized later, e.g. in NavigationController
            return;
        new AnchorNavigationContoller(navi); // eslint-disable-line no-new
    }
}
